// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"457":"137857ab","551":"2a37cce4","842":"8df647c5","851":"ec3ecaab"}[chunkId] + ".chunk.js";
};